import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { heroCheck, heroChevronLeft, heroFunnel } from '@ng-icons/heroicons/outline';
import { NgpSelectPortal } from 'ng-primitives/select';
import {
  UiBadge,
  UiCheckbox,
  UiEmptyText,
  UiFilterLabel,
  UiHint,
  UiIconButton,
  UiLabel,
  UiSelect,
  UiSelectDropdown,
  UiSelectOption,
  UiToggleGroup,
  UiToggleGroupItem,
} from '../../../../shared/ui';
import { ConversationFiltersStore } from '../../data/conversation-filters.store';

/** Inbox filter rail: scope, team, situation and tag filters. Drives {@link ConversationFiltersStore}. */
@Component({
  selector: 'app-conversation-filter-rail',
  imports: [
    NgIcon,
    NgpSelectPortal,
    UiBadge,
    UiCheckbox,
    UiEmptyText,
    UiFilterLabel,
    UiHint,
    UiIconButton,
    UiLabel,
    UiSelect,
    UiSelectDropdown,
    UiSelectOption,
    UiToggleGroup,
    UiToggleGroupItem,
  ],
  providers: [provideIcons({ heroCheck, heroChevronLeft, heroFunnel })],
  templateUrl: './filter-rail.html',
  styleUrls: ['./filter-rail.css', '../conversation-atoms.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterRailComponent {
  protected readonly filters = inject(ConversationFiltersStore);

  setFilterUnread(checked: boolean): void {
    if (this.filters.filterUnread() !== checked) this.filters.toggleFilterUnread();
  }

  onScopeChange(scope: unknown): void {
    const selected = Array.isArray(scope) ? scope[0] : scope;
    if (selected === 'all' || selected === 'mine') {
      this.filters.setActiveScope(selected);
    }
  }

  setTagSelected(tagId: string, checked: boolean): void {
    if (this.filters.isTagSelected(tagId) !== checked) this.filters.toggleTag(tagId);
  }

  onTeamChange(teamId: unknown): void {
    if (typeof teamId === 'string') {
      this.filters.setActiveTeam(teamId);
    }
  }

  onSituationChange(situationId: unknown): void {
    if (typeof situationId === 'string') {
      this.filters.setSituation(situationId);
    }
  }

  onStatusChange(status: unknown): void {
    if (typeof status === 'string') {
      this.filters.setStatus(status);
    }
  }

  onPriorityChange(priority: unknown): void {
    if (typeof priority === 'string') {
      this.filters.setPriority(priority);
    }
  }
}
